import CallServer from '../../api/CallServerV2';
export async function fetchLatestCommunication () {
    return await CallServer({
        endpoint: '/user/get_latest_communication',
        needAuthenticate: true,
        params: {
            type: 'popup'
        }
    })
} 

export async function markCommunicationAsViewed (communication_id) {
    return await CallServer({
        endpoint: '/user/mark_communication_as_viewed',
        needAuthenticate: true,
        params: {
            communication_id: communication_id
        }
    })
} 

export async function fetchGetNotifications (params = {}) {
    return await CallServer({
        endpoint: '/user/get_communications',
        params: params,
        needAuthenticate: true,
        retryIfFailed: true
    })
} 